import { FC } from 'react';

import './discoverProduct.scss';
import CircleLikeButton from 'components/circleLikeButton/CircleLikeButton';
import { IDiscoverProduct } from 'types';
import { Image } from 'components/helpers';
import TotalSavesTag from 'components/totalSavesTag/TotalSavesTag';

interface IDiscoverProductProps {
  item: IDiscoverProduct;
  onLikeClick(id: string, isLiked: boolean): void;
  onClick(id: string): void;
}

const DiscoverProduct: FC<IDiscoverProductProps> = ({ item, onLikeClick, onClick }) => {
  const { id, image, isLiked, totalLikes } = item;

  const onProductClick = (e: any) => {
    e.stopPropagation();
    onClick(id);
  };

  return (
    <div className="discover-product-container" onClick={onProductClick}>
      {totalLikes && <TotalSavesTag totalLikes={totalLikes} />}
      <Image src={image} withOverlay />
      <CircleLikeButton isLiked={isLiked} onClick={() => onLikeClick(id, isLiked)} />
    </div>
  );
};

export default DiscoverProduct;
